import axios from "axios";

export const getQrCodeUrlUs = () => axios.get(`/api/iamsmart/auth/qrcode-url-us`);

export const getQrCodeUrlHk = () => axios.get(`/api/iamsmart/auth/qrcode-url-hk`);

export const getQrCodeUrlCn = () => axios.get(`/api/iamsmart/auth/qrcode-url-cn`);

export const getQrCodeUrlPublicLoginUs = () => axios.get(`/api/iamsmart/auth/qrcode-url-public-login-us`);

export const getQrCodeUrlPublicLoginHk = () => axios.get(`/api/iamsmart/auth/qrcode-url-public-login-hk`);

export const getQrCodeUrlPublicLoginCn = () => axios.get(`/api/iamsmart/auth/qrcode-url-public-login-cn`);


export const RequestProfile = (businessID) => axios.post(`/api/iamsmart/request-profile/${businessID}`);

export const RequestProfileForInvitation = (businessID) => axios.post(`/api/iamsmart/request-profile-invitation/${businessID}`)

export const GetProfileRequest = (callback) => axios.post(`/api/iamsmart/get-profile-request`, callback);

export const getQrCodeForInvite = (lang) => axios.get(`/api/iamsmart/auth/get-reg-qrcode-invitation`,{
    params:{
        lang:lang
    }
});

export const getQrCodeForRegister = (lang) => axios.get(`/api/iamsmart/auth/get-reg-qrcode-register`,{
    params:{
        lang:lang
    }
});

export const getQrCodeForRegisterPublic = (lang) => axios.get(`/api/iamsmart/auth/get-reg-qrcode-register-public`,{
    params:{
        lang:lang
    }
});

export const getIAmSmartUrl = () => axios.get(`/api/systemsetting/module/8640515E-3141-4B42-B8BF-ADE84FA4F58B/public?keys=VUE_APP_IAM_SMART_APP_URL_SCHEME`);

export const getSession = (businessID) => axios.get(`/api/iamsmart/auth/session?businessID=${businessID}`);